import { Community, Contact, NotificationCommunity, NotificationRecordable, NotificationRecordableCategory, NotificationRecordableOwner, NotificationSubGroup, RecordableCategory, SubGroup } from './../../../../../../types';

export class NotificationRecordableViewModel extends NotificationRecordable {
    selectedCategories: RecordableCategory[] = [];
    selectedOwners: Contact[] = [];
    selectedCommunities: Community[] = [];
    selectedSubGroup: SubGroup = null;

    setProperties(notificationRecordable: NotificationRecordable, allRecordableCategories: RecordableCategory[], allRecordableOwners: Contact[], allCommunities: Community[], allSubGroups: SubGroup[]): void {
        this.notificationId = notificationRecordable.notificationId;
        this.notificationTypeId = notificationRecordable.notificationTypeId;
        this.notificationTypeName = notificationRecordable.notificationTypeName;
        this.edhMarketId = notificationRecordable.edhMarketId;
        this.edhContactId = notificationRecordable.edhContactId;
        this.createdBy = notificationRecordable.createdBy;
        this.createdUtcDate = notificationRecordable.createdUtcDate;
        this.lastModifiedBy = notificationRecordable.lastModifiedBy;
        this.lastModifiedUtcDate = notificationRecordable.lastModifiedUtcDate;
        this.notificationCommunities = notificationRecordable.notificationCommunities;
        this.notificationSubGroup = notificationRecordable.notificationSubGroup;
        this.notificationRecordableCategories = notificationRecordable.notificationRecordableCategories;
        this.notificationRecordableOwners = notificationRecordable.notificationRecordableOwners;

        //#region Convert PCP properties to EDH properties
        this.selectedCategories = notificationRecordable.notificationRecordableCategories
            .map((nrc: NotificationRecordableCategory) => this.getEdhCateogry(nrc, allRecordableCategories));

        this.selectedOwners = notificationRecordable.notificationRecordableOwners
            .map((nro: NotificationRecordableOwner) => this.getEdhOwner(nro, allRecordableOwners));

        if (notificationRecordable.notificationCommunities) {
            this.selectedCommunities = notificationRecordable.notificationCommunities
                .map((nc: NotificationCommunity) => this.getEdhCommunity(nc, allCommunities));
        } else {
            this.selectedCommunities = [];
        }

        this.selectedSubGroup = notificationRecordable.notificationSubGroup ? this.getEdhSubGroup(notificationRecordable.notificationSubGroup, allSubGroups) : null;
        //#endregion
    }

    mapEdhPropertiesToPcpProperties(marketId: number) {
        this.notificationRecordableCategories = this.getPcpCateogries();
        this.notificationRecordableOwners = this.getPcpOwners();
        this.notificationCommunities = this.getPcpCommunities();
        this.notificationSubGroup = this.getPcpSubGroup();
        this.edhMarketId = marketId;
    }

    getEdhCateogry(notificationRecordableCategory: NotificationRecordableCategory, allRecordableCategories: RecordableCategory[]): RecordableCategory {
        return allRecordableCategories.find((rc) => rc.id === notificationRecordableCategory.edhRecordableCategoryId);
    }

    getEdhOwner(notificationRecordableOwner: NotificationRecordableOwner, allRecordableOwners: Contact[]): Contact {
        return allRecordableOwners.find((ro) => ro.id === notificationRecordableOwner.edhContactId);
    }

    getEdhCommunity(notificationCommunity: NotificationCommunity, allCommunities: Community[]): Community {
        return allCommunities.find((c) => c.orgId === notificationCommunity.edhFinancialCommunityId);
    }

    getEdhSubGroup(notificationSubGroup: NotificationSubGroup, allSubGroups: SubGroup[]): SubGroup {
        return notificationSubGroup.subGroupId > 0 ? allSubGroups.find((s) => s.subGroupID === notificationSubGroup.subGroupId) : null;
    }

    getPcpOwners(): NotificationRecordableOwner[] {
        if (this.selectedOwners.length > 0) {
            return this.selectedOwners.map((c: Contact) => {
                const notificationRecordableOwner = new NotificationRecordableOwner();
                notificationRecordableOwner.edhContactId = c.id;
                notificationRecordableOwner.notificationId = this.notificationId;
                return notificationRecordableOwner;
            });
        }

        return [];
    }

    getPcpCommunities(): NotificationCommunity[] {

        if (this.selectedCommunities.length > 0) {
            return this.selectedCommunities.map((c: Community) => {
                const notificationCommunity = new NotificationCommunity();
                notificationCommunity.edhFinancialCommunityId = c.orgId;
                notificationCommunity.notificationId = this.notificationId;
                return notificationCommunity;
            });
        }

        return [];
    }

    getPcpCateogries(): NotificationRecordableCategory[] {

        if (this.selectedCategories.length > 0) {
            return this.selectedCategories.map((rc: RecordableCategory) => {
                const notificationRecordableCategory = new NotificationRecordableCategory();
                notificationRecordableCategory.edhRecordableCategoryId = rc.id;
                notificationRecordableCategory.notificationId = this.notificationId;
                return notificationRecordableCategory;
            });
        }

        return [];
    }

    getPcpSubGroup(): NotificationSubGroup {
        let notificationSubGroup = null;
        if (this.selectedSubGroup) {
            notificationSubGroup = new NotificationSubGroup();
            notificationSubGroup.subGroupId = this.selectedSubGroup.subGroupID;
            notificationSubGroup.notificationId = this.notificationId;
        }
        return notificationSubGroup;
    }

    getNotificationRecordable(): NotificationRecordable {

        const notificationRecordable: NotificationRecordable = new NotificationRecordable();

        notificationRecordable.notificationId = this.notificationId;
        notificationRecordable.notificationTypeId = this.notificationTypeId;
        notificationRecordable.notificationTypeName = this.notificationTypeName;
        notificationRecordable.edhMarketId = this.edhMarketId;
        notificationRecordable.edhContactId = this.edhContactId;
        notificationRecordable.createdBy = this.createdBy;
        notificationRecordable.createdUtcDate = this.createdUtcDate;
        notificationRecordable.lastModifiedBy = this.lastModifiedBy;
        notificationRecordable.lastModifiedUtcDate = this.lastModifiedUtcDate;
        notificationRecordable.notificationCommunities = this.notificationCommunities;
        notificationRecordable.notificationSubGroup = this.notificationSubGroup;
        notificationRecordable.notificationRecordableCategories = this.notificationRecordableCategories;
        notificationRecordable.notificationRecordableOwners = this.notificationRecordableOwners;

        return notificationRecordable;
    }
}